export default "__VITE_ASSET__2$LtLFQdS6IeO$uJxLxRJQ__"